<template>
	<p class="highlightable-text" v-html="treatedText"></p>
</template>

<script>
export default {
	name: 'HighlightableText',
	props: {
		text: {
			type: String,
			required: true
		}
	},
  computed: {
    treatedText() {
      return this.text.replace(/\*\*(.*?)\*\*/g, '<span class="highlighted-text">$1</span>')
    }
  }
}
</script>